export const environment = {
  production: true,
  BASE_URL: 'https://proxy1.citycar.co.il/api/',
  TEST_URL: 'https://clone.citycar.co.il/api/',
  GUEST_URL: 'https://clone.citycar.co.il/api/',
  NODE_SERVER: 'https://node.citycar.co.il/',
  LOCAL_NODE: 'https://localhost:3006/',
};
